// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2qH-m","title":"InfoRow_title__2GHOa"};